/**
 * Compact 1x / 1.1x / 1.5x / 2x speed buttons. Extracted from HelpVideo so
 * every audio or video player in the app offers speed the same way.
 */
import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

export const PLAYBACK_SPEEDS = [1, 1.1, 1.5, 2];

const PlaybackSpeedToggle = ({ value, onChange, speeds = PLAYBACK_SPEEDS }) => {
  const { t } = useTranslation("home");
  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={value}
      onChange={(_e, next) => {
        if (next != null) onChange(next); // ignore deselect (exclusive group)
      }}
      aria-label={t("playbackSpeed.label")}
    >
      {speeds.map((s) => (
        <ToggleButton
          key={s}
          value={s}
          aria-label={t("playbackSpeed.speed", { speed: s })}
          sx={{
            px: 0.9,
            py: 0.2,
            fontSize: "0.72rem",
            minWidth: 34,
            lineHeight: 1.2,
          }}
        >
          {s}&times;
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

PlaybackSpeedToggle.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  speeds: PropTypes.arrayOf(PropTypes.number),
};

export default PlaybackSpeedToggle;
